import {
  ADS_CHANNELS,
  EMAILS_CHANNELS,
  REVIEWS_CHANNELS,
  SOCIAL_CHANNELS,
  WEBSITE_CHANNELS,
} from 'src/data/channel';

import { EMAIL_CSV_RESOURCES, RESOURCE_DOCUMENT } from './resources';

export const RESOURCE_DOCUMENTS = Object.values(RESOURCE_DOCUMENT);

// TODO: why are we combining "channels" and "resources" here?
export const PERFORMANCE_CHANNELS = [
  ...WEBSITE_CHANNELS,
  ...REVIEWS_CHANNELS,
  ...ADS_CHANNELS,
  ...SOCIAL_CHANNELS,
  ...EMAILS_CHANNELS,
  ...RESOURCE_DOCUMENTS,
];

// TODO: and here as well?
export const EMAILS_CHANNELS_AND_RESOURCES = [...EMAIL_CSV_RESOURCES, ...EMAILS_CHANNELS];

export const ACCOUNT_FIELD = {
  toggle: 'toggle',
  id: 'id',
  name: 'name',
  connectedState: 'connectedState',
} as const;
export type AccountField = (typeof ACCOUNT_FIELD)[keyof typeof ACCOUNT_FIELD];

export const COPY_FIELD = {
  boost: 'boost',
  text: 'text',
  textType: 'textType',
  keywords: 'keywords',
  startDate: 'startDate',
  sourceAnyword: 'sourceAnyword',
  numberOfInstances: 'numberOfInstances',
  impressions: 'impressions',
  weightedCtr: 'weightedCtr',
  campaignNames: 'campaignNames',
  improve: 'improve',
  lifetimeConversions: 'lifetimeConversions',
  opens: 'opens',
  shares: 'shares',
  reactions: 'reactions',
  clicks: 'clicks',
  likes: 'likes',
  engagement: 'engagement',
  comments: 'comments',
  likesCount: 'like_count',
  quoteCount: 'quote_count',
  replyCount: 'reply_count',
  retweetCount: 'retweet_count',
  bookmarkCount: 'bookmark_count',
  impressionCount: 'impression_count',
} as const;
export type CopyField = (typeof COPY_FIELD)[keyof typeof COPY_FIELD];

export const TALKING_POINT_FIELD = {
  talkingPoint: 'talkingPoint',
  rating: 'rating',
  impressions: 'impressions',
  numberOfInstances: 'numberOfInstances',
  textType: 'textType',
};

export const CONNECT_TO_CHANNEL_ORIGIN = {
  integrationsAndResources: 'integrationsAndResources',
  benchmark: 'benchmark',
  copyAnalytics: 'copyAnalytics',
  customModels: 'customModels',
  onboarding: 'onboarding',
  performanceInsights: 'performanceInsights',
};

export const VISIBLE_TALKING_POINTS_PER_CHANNEL = 5;

export const LOADING_TALKING_POINTS_TEXT =
  'Learning historically high-performing talking points...';

export const EXTERNAL_CONNECTION_OBJECT_SEARCH = {
  all: 'all',
  lead: 'lead',
  contact: 'contact',
  account: 'account',
  opportunity: 'opportunity',
  case: 'case',
  quote: 'quote',
};

export const INTEGRATION_ASSET_ACTION = {
  connect: 'connect',
  disconnect: 'disconnect',
  dataDownload: 'data_download',
  createCustomModel: 'create_custom_model',
  createBenchmarkModel: 'create_benchmark_model',

  // deprecated
  deactivate: 'deactivate',
};

export const GENERATED_RESOURCE = {
  talkingPoints: 'talking_points',
  customModel: 'custom_model',
};
